import "./FrequentlyAskedQuestions.module.css";
import Header from "@/reusable_sections/Header";
import FashionFaq from "./sections/FashionFaq";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsPage() {
  return <div>
      <Header />
      <FashionFaq />
      <Footer />
    </div>;
}